import React from 'react';
import styled from 'styled-components';
import {
  BodyText,
  Button,
  ModalWindow,
  SwitchDialogWindows,
  ErrorMessage,
  Header3Text,
  Header4Text,
  FlexRow,
} from 'ui-toolkit';
import { useAsyncOperationWithData } from '../../utilities/accounting/hooks/useAsyncOperationWithData';
import { removeJournalEntryAsync } from '../../API/accounting/removeJournalEntryAsync';

const ButtonGrid = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing3};
  grid-auto-columns: max-content;
  grid-auto-flow: column;
`;

export interface IDeleteJournalEntryModalContainerProps {
  journalEntryId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export const DeleteJournalEntryModalContainer: React.FC<IDeleteJournalEntryModalContainerProps> = ({
  journalEntryId,
  onClose,
  onSuccess,
}) => {
  const [{ fetchStatus, fetchError }, deleteJournalEntry] = useAsyncOperationWithData(removeJournalEntryAsync);
  const onConfirmClick = () => deleteJournalEntry(journalEntryId);
  return (
    <SwitchDialogWindows
      isLoading={fetchStatus.fetching}
      isCompleted={fetchStatus.fetched}
      isError={!!fetchError}
      errorTitle={<Header3Text>There was an error deleting this Journal Entry</Header3Text>}
      loadingTitle="Deleting Journal Entry..."
      successTitle="Journal Entry was deleted."
      errorMessage={<ErrorMessage error={fetchError} />}
      onCloseClick={() => {
        if (!fetchStatus.fetching) {
          if (fetchStatus.fetched && fetchStatus.success) onSuccess();
          onClose();
        }
      }}
    >
      <ModalWindow
        title={<Header4Text>Delete Journal Entry</Header4Text>}
        onClose={onClose}
        footer={
          <FlexRow justifyContent={'flex-end'}>
            <ButtonGrid>
              <Button intent="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button intent="primary" onClick={onConfirmClick}>
                Confirm
              </Button>
            </ButtonGrid>
          </FlexRow>
        }
      >
        <BodyText>Are you sure you want to delete this Journal Entry?</BodyText>
      </ModalWindow>
    </SwitchDialogWindows>
  );
};
